import React, { Children, Component } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import IconInfo from "material-ui/svg-icons/action/info-outline";
import { reduxForm, formValueSelector, change } from "redux-form";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { GET_LIST } from "admin-on-rest";
import { RestClient } from "../restClient";
import getDefaultValues from "../components/form/getDefaultValues";
import { FormField, Toolbar } from "admin-on-rest";
import {
  ValuesForm,
  SearchCollectionsChip,
  ImageMultiCampaign
} from "../components";
import { Box } from "rebass";
import { red500 } from "material-ui/styles/colors";

class CampaignForm extends Component {
  handleSubmitWithRedirect = (redirect = this.props.redirect) =>
    this.props.handleSubmit(values => {
      this.props.save(values, redirect);
    });
  constructor(props) {
    super(props);
    const { record } = props;
    this.state = {
      collections: [],
      namecollections: [],
      isLoadcollections: true
    };
    if (record && record.collections && record.collections.length > 0) {
      this.getCollections(record.collections);
    }
  }
  getCollections(collections) {
    RestClient(GET_LIST, "collections", {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "name", order: "ASC" },
      filter: {}
    })
      .then(items => {
        if (items && items.data) {
          const res = items.data.filter(function(el) {
            return collections.indexOf(el.id) >= 0;
          });
          this.setState({
            collections: res
          });
        }
      })
      .catch(e => {
        // resolve([]);
      });
  }

  onChangecollections = collections => {
    const data = collections.map(item => {
      return item.id;
    });
    this.props.updateCollection(data);
  };
  renderImageBox(nameCampaign) {
    const { photos } = this.props;
    return (
      <div>
        <ImageMultiCampaign
          dataImage={photos}
          multiple={true}
          nameCampaign={nameCampaign}
          onUpdatePhotos={photos => this.props.updatePhotos(photos)}
          accept="image/*"
        />
      </div>
    );
  }

  render() {
    const {
      children,
      invalid,
      record,
      resource,
      basePath,
      submitOnEnter,
      toolbar,
      nameCampaign
    } = this.props;
    const { namecollections, collections } = this.state;
    return (
      <div>
        <form className="simple-form">
          <DivFormContainer px={[1, 2]}>
            {Children.map(
              children,
              input =>
                input && (
                  <div
                    key={input.props.source}
                    className={`aor-input-${input.props.source}`}
                    style={input.props.style}
                  >
                    <FormField
                      input={input}
                      resource={resource}
                      record={record}
                      basePath={basePath}
                    />
                    {input.props.source === "youtube_url" && (
                      <span data-tip="" data-for="youtubetooltip">
                        <IconInfo style={iconStyles} color={red500} />
                      </span>
                    )}
                  </div>
                )
            )}
            <ReactTooltip
              id="youtubetooltip"
              type="error"
              aria-haspopup="true"
              place="top"
            >
              <span>Please insert only youtube Id</span>
            </ReactTooltip>
          </DivFormContainer>
          <Box w={[1]} p={[1, 2]}>
            {nameCampaign && this.renderImageBox(nameCampaign)}
          </Box>
          <Box w={[1]}>
            <SearchCollectionsChip
              data={collections}
              nameCollections={namecollections}
              onChangeCollection={this.onChangecollections.bind(this)}
            />
          </Box>
          <ValuesForm isDebug={true} formName={"record-form"} />
          {toolbar &&
            React.cloneElement(toolbar, {
              handleSubmitWithRedirect: this.handleSubmitWithRedirect,
              invalid,
              submitOnEnter
            })}
        </form>
      </div>
    );
  }
}

CampaignForm.propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  handleSubmit: PropTypes.func, // passed by redux-form
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  save: PropTypes.func, // the handler defined in the parent, which triggers the REST submission
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
  validate: PropTypes.func
};

const DivFormContainer = Box.extend`
  padding-top: 3em;
  @media only screen and (min-width: 768px) {
    padding-bottom: 1em;
    padding-top: 0em;
  }
`;

CampaignForm.defaultProps = {
  submitOnEnter: false,
  toolbar: <Toolbar />
};
const selector = formValueSelector("record-form");
const enhance = compose(
  connect(
    (state, props) => {
      const collections = selector(state, "collections");
      const photos = selector(state, "photos");
      const nameCampaign = selector(state, "name");
      return {
        initialValues: getDefaultValues(state, props),
        collections,
        nameCampaign,
        photos
      };
    },
    {
      updatePhotos: photos => change("record-form", "photos", photos),
      updateCollection: collections =>
        change("record-form", "collections", collections)
    }
  ),
  reduxForm({
    form: "record-form",
    enableReinitialize: true
  })
);

const iconStyles = {
  marginLeft: 16,
  width: 24,
  height: 24
};

export default enhance(CampaignForm);



// WEBPACK FOOTER //
// ./src/campaigns/CampaignForm.js